export const OPEN_MY_INFO_LAYER = 'gnb/OPEN_MY_INFO_LAYER';
export const CLOSE_MY_INFO_LAYER = 'gnb/CLOSE_MY_INFO_LAYER';
export const TOGGLE_MY_INFO_LAYER = 'gnb/TOGGLE_MY_INFO_LAYER';

export const POST_CHANGED = 'post/POST_CHANGED';
export const POST_TITLE_CHANGE = 'post/POST_TITLE_CHANGE';
export const POST_CONTENT_CHANGE = 'post/POST_CONTENT_CHANGE';
export const POST_CATEGORY_CHANGE = 'post/POST_CATEGORY_CHANGE';
export const POST_VISIBILITY_CHANGE = 'post/POST_VISIBILITY_CHANGE';
export const POST_RECAPTCHA_VALUE_CHANGE = 'post/POST_RECAPTCHA_VALUE_CHANGE';
export const POST_SLOGAN_CHANGE = 'post/POST_SLOGAN_CHANGE';
export const POST_PUBLISHED_CHANGE = 'post/POST_PUBLISHED_CHANGE';
export const POST_DAUM_LIKE_CATEGORY_CHANGE = 'post/POST_DAUM_LIKE_CATEGORY_CHANGE';
export const POST_PASSWORD_CHANGE = 'post/POST_PASSWORD_CHANGE';
export const POST_ACCEPT_COMMENT_CHANGE = 'post/POST_ACCEPT_COMMENT_CHANGE';
export const POST_CCL_CHANGE = 'post/POST_CCL_CHANGE';
export const POST_TAG_ADD = 'post/POST_TAG_ADD';
export const POST_TAG_REMOVE = 'post/POST_TAG_REMOVE';
export const POST_TAG_UPDATE = 'post/POST_TAG_UPDATE';
export const POST_TAGS_SET = 'post/POST_TAGS_SET';
export const POST_THUMBNAIL_CHANGE = 'post/POST_THUMBNAIL_CHANGE';
export const POST_SET_DRAFT_SEQUENCE = 'post/POST_SET_DRAFT_SEQUENCE';
export const DRAFT_COUNT_UPDATE = 'post/DRAFT_COUNT_UPDATE';
export const UPDATE_TITLE_AND_CONTENT = 'post/UPDATE_TITLE_AND_CONTENT';
export const INCREASE_UPLOAD_PROGRESS_COUNT = 'post/INCREASE_UPLOAD_PROGRESS_COUNT';
export const DECREASE_UPLOAD_PROGRESS_COUNT = 'post/DECREASE_UPLOAD_PROGRESS_COUNT';

export const UPDATE_EDITOR_MODE = 'env/UPDATE_EDITOR_MODE';
export const CHANGE_EDITOR_STATUS = 'env/CHANGE_EDITOR_STATUS';
export const UPDATE_TOOLBAR_LEFT = 'env/UPDATE_TOOLBAR_LEFT';
export const SHOW_FOOTER = 'env/SHOW_FOOTER';
export const HIDE_FOOTER = 'env/HIDE_FOOTER';
export const UPDATE_MESSAGE = 'env/UPDATE_MESSAGE';
export const EDITOR_INITIALIZED = 'env/EDITOR_INITIALIZED';
export const RED_TITLE_PLACEHOLDER = 'env/RED_TITLE_PLACEHOLDER';

export const INIT_GOOGLE_PHOTOS = 'post/plugins/INIT_GOOGLE_PHOTOS';
export const RECEIVE_GOOGLE_PHOTOS_IMAGES = 'post/plugins/RECEIVE_GOOGLE_PHOTOS_IMAGES';

export const FOOTER_CHANGE_STATUS_TEXT = 'footer/CHANGE_STATUS_TEXT';
export const FOOTER_TOGGLE_STATUS_TEXT = 'footer/TOGGLE_STATUS_TEXT';

export const OPEN_LAYER_PLUGIN_MODAL = 'plugins/OPEN_LAYER_PLUGIN_MODAL';
export const CLOSE_LAYER_PLUGIN_MODAL = 'plugins/CLOSE_LAYER_PLUGIN_MODAL';

export const SAVE_SELECTION_RANGE = 'editor/SAVE_SELECTION_RANGE';
